import { IAddress, IAutocompleteResponse, IAutocompleteSuggestion } from '@curbnturf/entities';

export class AddressHelper {
  static autocompleteToString(autocomplete: IAutocompleteResponse): string {
    if (autocomplete.items.length === 0) {
      return '';
    }

    return AddressHelper.suggestionToString(autocomplete.items[0]);
  }

  static suggestionToString(suggestion: IAutocompleteSuggestion): string {
    const address = suggestion.address;
    return `${AddressHelper.getSuggestionHouseNumber(address)} ${AddressHelper.getSuggestionStreet(
      address,
    )} ${AddressHelper.getSuggestionCity(address)} ${AddressHelper.getSuggestionState(
      address,
    )} ${AddressHelper.getSuggestionZipcode(address)}`.trim();
  }

  static suggestionToAddress(suggestion: IAutocompleteSuggestion): IAddress {
    const suggestionAddress = suggestion.address;

    if (suggestionAddress) {
      return {
        address: `${AddressHelper.getSuggestionHouseNumber(suggestionAddress)} ${AddressHelper.getSuggestionStreet(
          suggestionAddress,
        )}`,
        city: AddressHelper.getSuggestionCity(suggestionAddress),
        state: AddressHelper.getSuggestionState(suggestionAddress),
        zipcode: AddressHelper.getSuggestionZipcode(suggestionAddress),
      };
    }

    return { address: '', city: '', state: '', zipcode: '' };
  }

  static addressToString(address: IAddress): string {
    return `${AddressHelper.getAddress(address)} ${AddressHelper.getCity(address)} ${AddressHelper.getState(
      address,
    )} ${AddressHelper.getZipcode(address)}`.trim();
  }

  static getAddress(address: IAddress): string {
    return address && address.address ? address.address : '';
  }

  static getCity(address: IAddress): string {
    return address && address.city ? address.city : '';
  }

  static getState(address: IAddress): string {
    return address && address.state ? address.state : '';
  }

  static getZipcode(address: IAddress): string {
    return address && address.zipcode ? address.zipcode : '';
  }

  static getSuggestionHouseNumber(address: IAutocompleteSuggestion['address']): string {
    return address && address.houseNumber ? address.houseNumber : '';
  }

  static getSuggestionStreet(address: IAutocompleteSuggestion['address']): string {
    return address && address.street ? address.street : '';
  }

  static getSuggestionCity(address: IAutocompleteSuggestion['address']): string {
    return address && address.city ? address.city : '';
  }

  static getSuggestionState(address: IAutocompleteSuggestion['address']): string {
    return address && address.state ? address.state : '';
  }

  static getSuggestionZipcode(address: IAutocompleteSuggestion['address']): string {
    return address && address.postalCode ? address.postalCode : '';
  }
}
